(function() {
  "use strict";

  angular
    .module("atcCallSign")
    .controller("AtcCallSignCtrl", AtcCallSignCtrl);

  function AtcCallSignCtrl(
    applicationConstants,
    AtcCallSignService,
    MessageService,
    AtcCallSignFactory,
    PopupManager
  ) {
    var vm = this;
    vm.ctrlName = 'AtcCallSignCtrl';
    vm.showRightPanel = false;

    vm.model = {
      searchPanelToggle: false,
      editorMode: null,
      searchCriteria: {
        fromDate: moment(new Date()).format('DD/MM/YYYY'),
        toDate: moment(new Date()).format('DD/MM/YYYY'),
        flightNo: null,
        atc: null,
        type:null
      },
      masterList: {
        validSearchInputs: true,
        datePickerOption: {
          minDate: null,
          maxDate: null
        }
      },
      atcCallSignDTOList: [],
      initialSearchDone: false,
      fromDateAfterToDate : false,
      selectedAtcRecord: null,
      atcType:[]
    };

    vm.model.masterList.atcType = [
      {title:'SCHEDULED', value: 'SCH'},
      {title:'AD-HOC', value: 'ADH'},
      {title:'ALL', value: null}
    ];

    searchAtcCallSignValue();

    vm.addCosmicRadiationValue = function() {
      vm.showRightPanel = true;
    };

    vm.onCloseCosmicRadiationEdit = function() {
      vm.showRightPanel = false;
    };

    vm.onSearch = function() {
      vm.model.searchPanelToggle = false;
      searchAtcCallSignValue();
    };

    function searchAtcCallSignValue(){
      AtcCallSignService.searchAtcCallSignValue(
        vm.model.searchCriteria,
        function(response){
          vm.model.atcCallSignDTOList = response;
        },
        function(error){
          MessageService.error(error);
        }
      );
    }

    vm.clickOnSearchATC = function () {
      vm.model.initialSearchDone = false;
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
    };


    vm.addATCValue = function() {
      vm.model.editorMode =  applicationConstants.EDITOR_STATUS.ADD;
      vm.model.selectedAtcRecord = AtcCallSignFactory.getNewSaveRequest();
      vm.showRightPanel = true;
    };

    vm.selectAtcRecord = function(selectedRowData) {
      vm.model.editorMode =  applicationConstants.EDITOR_STATUS.EDIT;
      vm.showRightPanel = true;
      vm.model.selectedAtcRecord = AtcCallSignFactory.setSelectedData(selectedRowData);
    };

    vm.submitAtcCallSign = function(event, action, selectedItem) {
      if(action === "delete"){
        vm.model.editorMode =  applicationConstants.EDITOR_STATUS.DELETE;
        var details = [];
        details.title = 'Confirmation';
        details.messages = ["Are you sure to Delete this entry?"];
        PopupManager.openModal('CONFIRM_DIALOG', details, confirmDailogue);

      }else{
        saveAtcCallSign();
      }
    };


    function saveAtcCallSign() {
      AtcCallSignService.saveAtcCallSign(vm.model.selectedAtcRecord, function(response){
          vm.model.selectedAtcRecord.pageSize = 10000;
          vm.model.searchCriteria.startPosition = 1;
          saveAtcCallSignMapping(vm.model.selectedAtcRecord);
       },
        function(error){
          console.log('Error save ATC Call Sign', error);
       }
      );

    }

    function saveAtcCallSignMapping(selectedAtcRecord){
      AtcCallSignService.saveConversionToMappingAtcCallSign(selectedAtcRecord, function(response){
          searchAtcCallSignValue();
          vm.showRightPanel = false;
        },
        function(error){
          console.log('Error inDelete ATC Call Sign', error);
        }
      );
    }

    vm.onCloseAtcEdit = function() {
      vm.model.selectedAtcRecord = AtcCallSignFactory.getNewSaveRequest();
      vm.showRightPanel = false;
    };


    vm.changeSearchField = function(event, flag, data, viewValue) {

    }


    vm.changeEditorField = function(value, flag, index, selectedItems) {
        if(flag === "CANCEL") {
            vm.onCloseAtcEdit();
        }

        if(flag === "validFrom"){
            vm.model.selectedAtcRecord.validToStr = vm.model.selectedAtcRecord.validFromStr;
        }
    };

    function confirmDailogue(pass) {
      if (pass == 'YES') {
         deleteAtcCallSign();
         /*searchAtcCallSignValue();
         vm.showRightPanel = false;*/

      }
    }

    function deleteAtcCallSign() {
      AtcCallSignService.deleteAtcCallSign(vm.model.selectedAtcRecord, function(response){
          vm.showRightPanel = false;

          vm.model.selectedAtcRecord.pageSize = 10000;
          vm.model.selectedAtcRecord.startPosition = 1;
          vm.model.selectedAtcRecord.atcCallSign="";
          saveAtcCallSignMapping(vm.model.selectedAtcRecord);
        },
        function(error){
          console.log('Error inDelete ATC Call Sign', error);
        }
      );
    }

  }
})();
